// Shared "unsaved changes" tracking for the editor surfaces.
//
// The host component owns a `model` object; `snapshot(value)` records the
// serialised state that is known to be on the server (after a load and after a
// save), and `isDirty` compares the live model against it. Nothing here talks
// to the network — the host decides what saving means.
export default {
  data() {
    return {
      savedSnapshot: '',
      leaveDialogOpen: false,
      pendingNext: null,
    };
  },

  computed: {
    isDirty() {
      return JSON.stringify(this.model) !== this.savedSnapshot;
    },
  },

  methods: {
    snapshot(value) {
      this.savedSnapshot = JSON.stringify(value);
    },

    // Move a few named keys onto the saved baseline without re-baselining the
    // rest of the model. Used when something other than the user changes the
    // model — an encoder poll, a publish toggle — so those changes never look
    // like unsaved edits and never swallow the edits the user *has* made.
    patchSnapshot(keys, source) {
      if (!this.savedSnapshot) return;
      const saved = JSON.parse(this.savedSnapshot);
      keys.forEach(key => {
        saved[key] = source[key];
      });
      this.savedSnapshot = JSON.stringify(saved);
    },

    // Used by `beforeRouteLeave`: hold the navigation and ask first.
    confirmLeave(next) {
      this.pendingNext = next;
      this.leaveDialogOpen = true;
    },
  },
};
